import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import axios from 'axios';
import moment from 'moment';

const ViewCoupon = ({ show, onClose, selectedId }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [data, setData] = useState([]);
    const [subscriberDetails, setsubscibers] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        axios.get(`${baseURL}/coupon/${selectedId}`)
            .then(response => {
                setData(response.data.data);
                setsubscibers(response.data.subscribers);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
                setHasFetched(true);
            });

    }, []);

    const tableRef = useRef(null);
    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "250px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Coupon</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Coupon</label>
                            <label className='text-black fs-6 font-w500'>{data.coupon_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Coupon Value</label>
                            <label className='text-black font-w500 fs-6 '>
                                {(parseFloat(data.coupon_value) % 1 === 0 ? parseFloat(data.coupon_value).toFixed(0) : parseFloat(data.coupon_value).toFixed(2))} ({data.coupon_type == 0 ? 'Amount' : 'Percentage'})
                                {/* <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                <span>100</span> */}
                            </label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Coupon Type</label>
                            <label className='text-info fs-6 font-w600'>{data.coupon_for === 0 ? 'Welcome Offer' : 'Recursion'}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Coupon Code</label>
                            <label className='text-black fs-6 font-w500'>
                                <Badge bg="success" className='text-white fs-7 py-0 px-1'>{data.coupon_code}</Badge>
                            </label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>End Date</label>
                            <label className='text-red fs-6 font-w500'>{moment(data.enddate).format('DD-MMM-YYYY')}</label>
                        </div>
                    </div>
                    {subscriberDetails.length > 0 && (
                        <div className="table-container" >
                            <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-100px text-start'>Date</th>
                                        <th className='min-w-100px'>Subscriber</th>
                                        <th className='min-w-100px text-center'>Product Count</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {subscriberDetails.map((data, index) => (
                                        <tr>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.used_at}</label>
                                            </td>
                                            <td>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.lead_name}</div>
                                                <div className='d-block'>
                                                    <div className='text-dark font-w600 fs-8'>{data.mobile}</div>
                                                </div>
                                            </td>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>{data.product_count}</label>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ViewCoupon;
